import { TGlobalState } from 'reducers';

export const getBookableAppointments = (state: TGlobalState) =>
  state?.bookableAppointments?.appointments;

export const getBookableAppointmentServiceProviders = (state: TGlobalState) =>
  state?.bookableAppointments?.serviceProviders;

export const getMaxAppointmentsWarning = (state: TGlobalState) =>
  state?.bookableAppointments?.maxAppointmentsWarning;
